import { render, staticRenderFns } from "./TrendSection.vue?vue&type=template&id=45c99725&scoped=true"
import script from "./TrendSection.vue?vue&type=script&lang=ts"
export * from "./TrendSection.vue?vue&type=script&lang=ts"
import style0 from "./TrendSection.vue?vue&type=style&index=0&id=45c99725&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c99725",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrendTitle: require('/app/components/Metrics/Trend/TrendTitle.vue').default,ZDivider: require('/app/components/zeal/ZDivider/ZDivider.vue').default,TrendStat: require('/app/components/Metrics/Trend/TrendStat.vue').default,ZChart: require('/app/components/zeal/ZChart/ZChart.vue').default})
